import { Component, Input, OnDestroy } from '@angular/core';
import {
  ReactiveFormsModule,
  FormsModule,
  NonNullableFormBuilder,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { DialogService } from '../../../../../core/services/dialog/dialog.service';
import { ToastService } from '../../../../../core/services/toast/toast.service';
import { DelegatedUIErrorI } from '../../../../interfaces/delegated-ui-error.interface';
import { OtpInputComponent } from '../../../form-controls/otp-input/otp-input.component';
import { DialogActionButtonsComponent } from '../../shared/dialog-action-buttons/dialog-action-buttons.component';
import { FirstTimeLoginApiService } from '../../../../../pages/auth/first-time-login/first-time-login-api.service';
import { NewPasswordComponent } from '../new-password/new-password.component';

@Component({
  selector: 'app-password-otp',
  imports: [
    TranslateModule,
    DialogActionButtonsComponent,
    OtpInputComponent,
    ReactiveFormsModule,
    FormsModule,
  ],
  templateUrl: './password-otp.component.html',
  styleUrl: './password-otp.component.scss',
})
export class PasswordOtpComponent implements OnDestroy {
  constructor(
    private readonly fb: NonNullableFormBuilder,
    private readonly dialogService: DialogService,
    private readonly toastService: ToastService,
    private readonly firstTimeLoginApiService: FirstTimeLoginApiService
  ) {}

  private readonly destroy$ = new Subject<void>();

  @Input({ required: true })
  email!: string;

  requestOtpForm = this.fb.group({
    otp: [
      '',
      [Validators.minLength(6), Validators.maxLength(6), Validators.required],
    ],
  });

  sendOtp() {
    this.firstTimeLoginApiService
      .requestOtp(this.email)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (createOtpForDeleteFaculty) => {
          this.toastService.showSuccess(
            createOtpForDeleteFaculty.frontFacingMessage
          );
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }

  otpVerification() {
    this.firstTimeLoginApiService
      .checkFirstTimeLogin({
        email: this.email,
        otp: this.requestOtpForm.controls.otp.value,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (createOtpForDeleteFaculty) => {
          const data = createOtpForDeleteFaculty.data;
          if (data.isCorrect) {
            this.dialogService.closeDialog();

            this.dialogService.openDialog(NewPasswordComponent, {
              otp: this.requestOtpForm.controls.otp.value,
              email: this.email,
            });
          } else {
            this.toastService.showError('OTP is not correct');
          }
        },
        error: (err: DelegatedUIErrorI) => {
          this.toastService.showError(err.description, err.title);
        },
      });
  }
  onSubmit() {
    this.otpVerification();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
